import React, { useState, useEffect, useRef, useContext } from 'react';
import _ from 'lodash';
import { useOutsideClick } from 'utils/helpers';
import { WorkReportContext } from './WorkReportForm';
import { ClickAwayListener } from '@material-ui/core';

const TreeEditableCell = (props) => {
  const { value: initialValue, name, item, type, onChange, className = '', inputProps = {}, style = {}, readOnly = false } = props;
  const [value, setValue] = useState(initialValue);
  const handleClickOutside = (ignoreChange = false) => {
    if (initialValue !== value && !ignoreChange) onChange({ name, value, item });
    setIsEditing(false);
  };

  const inputRef = useRef(null);
  const { setEstimateCurrentEditable, estimateCurrentEditable } = useContext(WorkReportContext);
  const currentBeingEdited = estimateCurrentEditable?.id === item.id && estimateCurrentEditable?.name === name;
  const [isEditing, setIsEditing] = useState(currentBeingEdited);


  useEffect(() => {
    if (!isEditing) return;

    inputRef.current?.focus();
  }, [isEditing]);

  const handleOnChange = (newValue) => {
    setValue(newValue);
  };

  const handleOnKeyDown = (e) => {
    if (e.shiftKey) e.stopPropagation();  // Prevent SHIFT key from losing focus of input

    if (e.keyCode === 13) handleClickOutside();

    if (e.key === 'Escape') {
      setValue(initialValue);
      handleClickOutside(true);
    }
  };

  let input;
  switch (type) {

    case 'textarea':
      input = (
        <div className="popout-input">
          <textarea ref={inputRef} {...inputProps} onKeyDown={handleOnKeyDown} onChange={(e) => handleOnChange(e.target.value)} value={value} />
        </div>
      );
      break;

    default:
      input = <input ref={inputRef} {...inputProps} onKeyDown={handleOnKeyDown} onChange={(e) => handleOnChange(e.target.value)} value={value} />;
  }

  return readOnly ? (
    <div style={style} className={`tree-editable-cell ${className}`} title={value}>
      {(value === null || value === undefined || value === '') ? <>&nbsp;</> : value}
    </div>
  ) : (
    <ClickAwayListener onClickAway={() => handleClickOutside()}>
      <div onClick={() => setIsEditing(true)} style={style} className={`tree-editable-cell ${className} ${isEditing ? 'is-editing' : ''}`} title={value}>
        {isEditing ? input : ((value === null || value === undefined || value === '') ? <>&nbsp;</> : value)}
      </div>
    </ClickAwayListener>
  );
}

export default TreeEditableCell;